import { createImageFile } from "./mockUtils";

export const getStaticAsset = fileName => {
  return `${window.location.origin}/static/media/${fileName}`;
};

export const getStaticImage = image => {
  return createImageFile(`${process.env.APP_IMAGE_URL}/${image}`);
};
